import { useNavigate } from 'react-router-dom';
import clsx from 'clsx';
import styles from './EntityFormPage.module.css';

export default function EntityFormPage({ title, backTo, wide, full, fullHeight, children }) {
  const navigate = useNavigate();

  return (
    <div
      className={clsx(
        styles.page,
        wide && styles.pageWide,
        full && styles.pageFull,
        fullHeight && styles.pageFullHeight,
      )}
    >
      <div className={styles.header}>
        <button
          type="button"
          className={styles.backBtn}
          onClick={() => navigate(backTo)}
          aria-label="Back"
        >
          <i className="pi pi-arrow-left" />
        </button>
        <h1>{title}</h1>
      </div>
      <div className={clsx(styles.formArea, fullHeight && styles.formAreaFullHeight)}>{children}</div>
    </div>
  );
}
